document.querySelectorAll(".social-video.js").forEach(section => {
  section.classList.remove("js");

  const swiper = section.querySelector(".swiper");
  const swiperPagination = section.querySelector(".swiper-pagination");
  const swiperButtonNext = section.querySelector(".swiper-button-next");
  const swiperButtonPrev = section.querySelector(".swiper-button-prev");
  const slider = new Swiper(swiper, {
    slidesPerView: 1.15,
    grabCursor: true,
    centeredSlides: true,
    spaceBetween: 12,
    pagination: {
      el: swiperPagination,
      clickable: true,
    },
    navigation: {
      nextEl: swiperButtonNext,
      prevEl: swiperButtonPrev,
    },
    breakpoints: {
      750: {
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
  });
  if (window.innerWidth <= 750) {
    slider.slideTo(1);
  }

  section.querySelectorAll('.social-video__video').forEach((videoWrapper, index) => {
    const playButton = videoWrapper.querySelector('.social-video__play-button');
    const videoElement = videoWrapper.querySelector('video');
    videoWrapper.addEventListener('click', toggleVideo);

    function toggleVideo() {
      if (videoElement.paused) {
        section.querySelectorAll("video").forEach(video => {
          video.pause();
        });
        videoElement.play();
      } else {
        videoElement.pause();
      }
    }

    videoElement.addEventListener('ended', () => {
      slider.slideNext();
      playButton.style.display = 'block';
      const activeSlide = section.querySelector(".swiper-slide-active");
      const videoElement = activeSlide.querySelector('video');
      if (videoElement && videoElement.paused) {
        videoElement.play();
      }
    });

    videoElement.addEventListener('play', () => {
      playButton.style.display = 'none';
    });

    videoElement.addEventListener('pause', () => {
      playButton.style.display = 'block';
    });
  });
});
